export const educationCheckActionTypes = {
	TOGGLE_EDUCATION_CHECK_MODAL: 'TOGGLE_EDUCATION_CHECK_MODAL',
	TOGGLE_REVIEW_TOPICS_MODAL: 'TOGGLE_REVIEW_TOPICS_MODAL',
	SET_MISTAKE_INTERVENTION_ID: 'SET_MISTAKE_INTERVENTION_ID',
} as const;
